export const endPoints = { 

    //  baseUrl: 'http://localhost:8000/',  
    //  apiBaseUrl: 'http://localhost:8000/api',  

     baseUrl: 'https://social-shipping.com/',
     apiBaseUrl: 'https://api.jetcamer.com/social-shipping/api',
  
    api: {
      // TravelerLogin:"auth/traveler/login",
      UserLogin:"auth/users/login",
      UserRegister:"auth/users/register",
      // SenderLogin:"auth/users/login",
      // SenderRegister:"senders/register",
      // TravelerRegister:"travelers/register",
      Location:"locations",
      TravelerAllData:"get-all-traveler",
      // TravelerInfo:"get-traveler-info",
      AddTravelerInfo:"create-traveler-info",
      UpdateTravelerInfo:"update-traveler-info",
      AddSenderInfo:"/create-sender-info",
      UPDATE_PROFILE_IMAGE:"/update-profile-image",
      UPDATEPROFILEIMAGESENDER:"/sender-upload",
      GETBYTRAVELERID:"/users",
      GETBYSENDERID:"/users",
      // GETBYSENDERID:"/sender",
      FaqsAllData:"/get-faqs-list",
      QUERYSUBMIT:"/query-form-submit",
      GET_COUNTRY:"/getCountries",
      GETSTATES:"/getStates",
      GETCITY:"/getCities",
      GET_TRAVEL_INFO:"/get-traveler-info/",
      HOME_PAGE_DATA:"/home-page",
      ABOUT_PAGE_DATA:"/about-page",
      SENDER_PAGE_DATA:"/sender-page",
      TRAVELER_PAGE_DATA:"/traveler-page",
      HOWITWORKS_DATA:"/how-it-works",
      CONTACT_PAGE_DATA:"/contact-page",
      HOME_PAGE_DATA_FINAL:"/home-page-data",
      RESET_PASSWORD:"/reset-password",
      CHANGE_PASSWORD:"/change-password",
      AddPaymentInfo:"/paypal/payment/confirm",
       
    },
    mode: "Development",
  };
 
  // export const Image_Url = "http://localhost:8000/upload/images/" 
  export const clientId = "ARnegOkC9eGTAwTZvcbr3ppnznMGomAlYgxs3b5Nw7ecohG6u2jr9TncRnDvgN1NO4BTUPE4OdgNMNq8" 
  export const Image_Url = "https://api.jetcamer.com/social-shipping/upload/images/"
 
  
  export default {};
